export function Warn(...args) {
  window.console && window.console.warn(...args);
}

export const watchAddedNodes = async (callback, querySelector, immediate = true) => {
  const throttle = await import('./_utilities/throttle');
  if (!callback || typeof callback !== 'function') throw new Error('callback must be a function');
  if (!querySelector) throw new Error('querySelector must have a value');

  if (immediate) {
    const initialElements = Array.from(document.querySelectorAll(querySelector));
    callback(initialElements);
  }

  const observer = new MutationObserver((mutationsList) => {
    let elements = [];
    const debouncedClbk = throttle.debounce(
      () => {
        callback(elements);
      },
      250,
      false
    );
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        const nodes = Array.from(mutation.addedNodes).filter((node) => node.nodeType === 1);
        const selfNodes = nodes.filter(
          (node) => !querySelector || node.matches(querySelector)
        );
        const innerNodes = nodes
          .filter(
            (node) => querySelector && node.querySelector(querySelector))
          .map((node) => Array.from(node.querySelectorAll(querySelector)))
          .reduce((a, b) => a.concat(b), []);
        elements = [...elements, ...selfNodes, ...innerNodes];
      }
    }

    if (elements && elements.length) {
      debouncedClbk();
    }
  });
  observer.observe(document, {
    childList: true,
    subtree: true,
  });
  return observer;
};

export const domIsReady = () => new Promise((resolve) => {
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    // resolve if we are after pageload
    resolve();
  }
  if (!document.attachEvent || typeof document.attachEvent === 'undefined') {
    document.addEventListener('DOMContentLoaded', () => { resolve(); });
    document.addEventListener('readystatechange', () => {
      if (document.readyState === 'complete' || document.readyState === 'interactive') {
        resolve();
      }
    });
  } else {
    document.attachEvent('onreadystatechange', () => {
      if (document.readyState === 'complete' || document.readyState === 'interactive') {
        resolve();
      }
    });
  }
});
